module.exports = __webpack_public_path__ + "static/media/horsefire_site.18305315.jpg";